export interface Rule {
  RuleId: number;
  RuleName: string;
  RuleType: string;
  ExecutionOrder: number;
  ExecutionMode?: "STANDARD" | "ALWAYS";
  Active: string;
}

export interface FieldOption {
  id: string;
  label: string;
  value: string;
}

export const SYSTEM_FIELDS: FieldOption[] = [
  { id: "created_by", label: "Created By", value: "created_by" },
  { id: "updated_by", label: "Updated By", value: "updated_by" },
  { id: "created_date", label: "Created Date", value: "created_date" },
  { id: "updated_date", label: "Updated Date", value: "updated_date" },
];

export const EL_SYSTEM_FIELDS: FieldOption[] = [
  { id: "el_created_by", label: "EL Created By", value: "el_created_by" },
  { id: "el_updated_by", label: "EL Updated By", value: "el_updated_by" },
  { id: "el_created_date", label: "EL Created Date", value: "el_created_date" },
  { id: "el_updated_date", label: "EL Updated Date", value: "el_updated_date" },
];

export interface ApprovalConfigProps {
}
